import store from 'mt-react-common/createStore';
import { isAuth, logout } from 'utils/authHelper';
import { addClientNotice } from 'mt-react-common/modules/main/reducers/static/states/clientNotices/reducer';

export default async response => {
  if (response) {
    const responseJson = await response.json();
    if ([500, 400, 403, 409].includes(response.status)) {
      store.dispatch(addClientNotice('danger', responseJson.data.message));
    } else if (response.status === 401) {
      if (isAuth()) {
        logout();
      }
    }
    return responseJson;
  }
  store.dispatch(
    addClientNotice('error', 'Не удалось выполнить запрос к серверу.')
  );
  return null;
};



// WEBPACK FOOTER //
// ./src/utils/handlerResponse.js